import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import buyPortfolio from 'images/buy.png';
import redeemIcon from 'images/redeem.png';
import PortfolioRedeem from './portfolio-redeem';
import FolioInvestment from './portfolio-invest-more';
import stpIcon from 'images/stpPortfolioGrey.png';
import './index.css';
import ConfirmationModal from 'components/confirmation-modal';
import { showKnowMoreRegister } from 'views/know-more/know-more-helper';
import KnowMorePopup from 'views/know-more/know-more-popup';
import { SuccessButton } from 'components/button';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import UserSelector from 'views/user/user.selector';
import LAMFPopup from './lamf-popup';
import { Mixpanel, getEventName } from '__utils/mixpanel';
import RedeemPageThankYouPopup from './lamf-redeem-page-thank-you-popup';
import { isProUser } from '__utils/common-utils';

interface OperationPopup {
	portfolioRecord: any;
}

const FolioOperations: React.FC<OperationPopup> = ({ portfolioRecord }) => {
	const isMobile = useMediaQuery({ maxWidth: 767 });
	const history = useHistory();
	const { isAgentNotAllowed } = propsToJS(useSelector(UserSelector));
	const [showFolioRedeem, setShowFolioRedeem] = useState<{
		open: boolean;
		folioData?: any;
	}>({ open: false });
    const [showKnowMorePopup, setShowKnowMorePopup] = useState<boolean>(false);
	const [showWarningPopup, setShowWarningPopup] = useState<boolean>(false);
	const [showFolioInvestment, setShowFolioInvestment] = useState<{
		open: boolean;
		folioData?: any;
	}>({ open: false });

	const [showLAMFPopup, setShowLAMFPopup] = useState<boolean>(false);
	const [showThankYouPopup, setShowThankYouPopup] = useState<any>(false);

	const majorStatus = sessionStorage.getItem('majorStatus') || '';

	const openRedeemPopup = (record: any) => {
		document.body.style.overflow = 'scroll';
		if (showLAMFPopup) {
            setShowLAMFPopup(false);
        }
		setShowFolioRedeem({ open: true, folioData: record });
	};
	const openInvestmentPopup = (record: any) => {
		setShowFolioInvestment({ open: true, folioData: record });
	};
	const onPopupClose = (redeemSuccess: any) => {
		setShowFolioRedeem({ open: false });
		setShowFolioInvestment({ open: false });
		if (redeemSuccess === 'redeemSuccess') {
			window.location.reload();
		}
	};
    const registerDp = () => {
        setShowWarningPopup(false);
        showKnowMoreRegister();
        setShowKnowMorePopup(true);
    }

	const registerLAMFDP = () => {
		document.body.style.overflow = 'scroll';
		if (showLAMFPopup) {
            setShowLAMFPopup(false);
        }
        Mixpanel.track(getEventName('LAMF-Popup', 'clicked', 'home'))
		const partner = sessionStorage.getItem('agentCodeMintpro');
        //setShowThankYouPopup(true);
		window.open(`https://app.turtlefin.com/products/lamf?partnerId=${partner}`);
       
	}

	const openLAMFPopup = () => {
		setShowLAMFPopup(true);
		document.body.style.overflow = 'hidden';
	}

	return (
		<div>
			<div className={isMobile ? 'operationList' : 'dropdownTable'}>
				{portfolioRecord.metaData.allowPur &&
					(portfolioRecord?.metaData?.minLumpsumAmount > 0 ||
						(portfolioRecord?.metaData?.minSipAmount > 0 &&
							portfolioRecord?.metaData?.sipData?.length >
								0)) && (
						<p
							className={majorStatus ? 'disabledBtn' : ''}
							onClick={() => openInvestmentPopup(portfolioRecord)}
						>
							<img src={buyPortfolio} alt="invest more" />
							<span> Invest More</span>
						</p>
					)}

				{portfolioRecord?.redemptionAllowed && (
					<p
						className={
							majorStatus
								? 'disabledBtn'
								: portfolioRecord?.tagToDisplay === 'all'
								? `disabled`
								: ''
						}
						onClick={() => isProUser() ? openLAMFPopup() : openRedeemPopup(portfolioRecord)}
					>
						<img src={redeemIcon} alt="redeem" />
						<span>Redeem</span>
					</p>
				)}

				{portfolioRecord.unitsAllocated &&
				portfolioRecord.stpFlag == 'Y' ? (
					<p
						className={majorStatus ? 'disabledBtn' : ''}
						onClick={() =>
							history.push(
								`/profile/stps/create-new-stp?schemeId=${portfolioRecord?.metaData?.schemeId}&folio=${portfolioRecord?.folioNo}`
							)
						}
					>
						<img src={stpIcon} alt="stp" />
						<span> STP</span>
					</p>
				) : null}
			</div>
			{showFolioRedeem.open && (
				<PortfolioRedeem
					folioData={showFolioRedeem?.folioData}
					onCancel={onPopupClose}
				/>
			)}
			{showFolioInvestment.open && (
				<FolioInvestment
					folioData={showFolioInvestment?.folioData}
					onCancel={onPopupClose}
				/>
			)}
			{showWarningPopup && (
				<ConfirmationModal
					title="Uh Oh!"
                    onCancel={()=> setShowWarningPopup(false)}
					modalBody={
						<div className='mb16'>
							<h4>
								Please submit your NISM Certificate and ARN Card
								copy to be able to sell Mutual Funds.
							</h4><br/>
                            <SuccessButton onClick={() => registerDp()}>Continue</SuccessButton>
                            <br/>
						</div>
					}
					closable={true}
				></ConfirmationModal>
			)}
            {showKnowMorePopup && <KnowMorePopup onClose={() => setShowKnowMorePopup(false)}  />}
			{showLAMFPopup && <LAMFPopup onClose={() => {
				document.body.style.overflow = 'scroll';
				setShowLAMFPopup(false);
				}} 
			registerLAMFDP = {registerLAMFDP} openRedeemPopup={openRedeemPopup} portfolioRecord={portfolioRecord} />}
			{showThankYouPopup && <RedeemPageThankYouPopup onClose={() => {document.body.style.overflow = 'scroll';
			setShowThankYouPopup(false)}}  />}
		</div>
	);
};

export default FolioOperations;
